import React from "react";
import ActivityPage from "../activity/ActivityPage";
import {useSelector} from "react-redux";
import AuthorHomepage from "../contribute/homepage/AuthorHomepage";

const Homepage = ({}) => {
    const userRole = useSelector(state => state.userIdentity.userRole);
    return userRole === "AUTHOR" ? <AuthorHomepage/> : <ActivityPage/>;
};

export default Homepage;
